import { Controller, useForm } from "react-hook-form";
import { Dialog } from "components/Dialog";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import { TProvince } from "types/dto";

type TProps = {
  record?: TProvince;
  isOpen?: boolean;
  onClose: () => void;
  onSubmit: (value: TEditFormTypes) => void;
  isLoading: boolean;
};

export type TEditFormTypes = {
  name: string;
};

export function EditProvinceModal(props: TProps) {
  const { isOpen = false, onClose, onSubmit, isLoading, record } = props;

  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<TEditFormTypes>({
    defaultValues: {
      name: record?.name,
    },
  });

  return (
    <Dialog
      maxWidth={false}
      dialogTitle={t("editProvince")}
      open={isOpen}
      onClose={onClose}
      canClose={!isLoading}
    >
      <form className="p-4 w-[640px]" onSubmit={handleSubmit(onSubmit)}>
        <div>
          <span>{t("editProvince")}</span>
          <span className={"text-primary-60 font-bold mr-1"}>
            {record?.name}
          </span>
        </div>
        <div className="flex w-1/2 mt-4">
          <Controller
            name={"name"}
            control={control}
            rules={{
              required: "الزامی است",
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  label={t("provinceName")}
                  placeholder={t("provinceName")}
                  size="small"
                  {...field}
                  error={Boolean(error)}
                  className={"w-full"}
                />
              );
            }}
          />
        </div>
        <div className="col-span-12 flex items-center justify-end mt-3">
          <Button
            className="w-20"
            loading={isLoading}
            type="submit"
            variant="contained"
          >
            {t("edit")}
          </Button>
        </div>
      </form>
    </Dialog>
  );
}
